// Delegate clicks so toggles also work after Shopify replaces a product section.
(() => {
  if (window.t2cReadMoreInitialized) return;
  window.t2cReadMoreInitialized = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.t2c-rm__btn');
    if (!button) return;
    const rest = button.closest('.t2c-rm')?.querySelector('.t2c-rm__rest');
    if (!rest) return;
    const open = rest.hasAttribute('hidden');
    rest.toggleAttribute('hidden', !open);
    button.setAttribute('aria-expanded', String(open));
  });
})();
